import { createAsyncThunk } from '@reduxjs/toolkit';
import { httpService } from '../../..';
import { executeApiRequest } from '../../asyncUtils';
import { uiActionCreators } from '../../ui';
import { logisticsActionCreators } from '../logisticsActionCreators';
import { IShipmentItem } from '../logisticsInterfaces';

export const fixShipmentItemNamesThunk = createAsyncThunk(
  'logistics/fixShipmentItemNames',
  async (shipmentId: number, { dispatch, rejectWithValue }) => {
    dispatch(uiActionCreators.showSpinnerDialog(`Fixing Item Names for Shipment ${shipmentId}`));
    const response = await executeApiRequest<IShipmentItem[]>(() =>
      httpService.post(`/Shipments/${shipmentId}/FixItemNames`)
    );
    dispatch(uiActionCreators.hideSpinnerDialog());

    if (response.requestFailed) {
      return rejectWithValue(`Failed to fix item names for shipment ${shipmentId}`);
    }

    // TODO: Remove this dispatch when you convert this to a slice
    dispatch(logisticsActionCreators.setShipmentItems(response.value ?? []));

    return response.value ?? [];
  }
);
